import React from "react";
import partImg from "images/part.png";
import serviceImg from "images/service.png";

const LineItemPreview = ({ data }: { data: any }) => {
  const { 
    total_only: totalOnly,
    include_images: showImage, 
    name: showName,
    include_line_total: showLineTotal, 
    include_qty: showQty, 
    products: showParts,
    services: showServices,
    short_description: showShortDescription,
    long_description: showLongDescription,
    } = data;

  const items = (item: string) => {
    const img = item === "part" ? partImg : serviceImg;
    const itemString = item === "part" ? "Part" : "Service";
    const includeParts = item === "part" && showParts;
    const includeServices = item === "service" && showServices;

    return (
      <div className="flex flex-1 p-3 space-x-4">
        {showImage && <img className="w-[35px] h-[35px]" src={img} alt={item} />}
        {includeParts || includeServices ? (
          <div className="flex flex-col">
            {showName && <div className="text-sm capitalize font-[800]">{itemString}</div>}
            {showShortDescription && <div className="text-sm font-medium capitalize">{itemString} #1</div>}
            {showLongDescription && <div className="text-xs text-gray-500">{itemString} #1 w/ Attachments</div>}
          </div>
        ) : (
          <div className="font-[800]">{itemString}s</div>
        )}

        <div className="flex-grow" />
        {includeParts || includeServices ? (
          <div>
            {showQty && 
              <div className="text-sm font-medium w-[100px]">
                {showLineTotal && <span>(1) x </span>}
                <span>$100.00</span>
              </div>
            }
          </div>
        ) : (
          <div className="w-[100px]">- -</div>
        )}  
        {showLineTotal && <div className="text-sm font-medium w-[100px]">$100.00</div>}
      </div>
    )
  }

  return (
    <div className={`border rounded-lg`}>
      <div className="bg-[#e5e7eb] p-3 flex flex-1 space-x-4">
        {showImage && !totalOnly && <div className="w-[35px]" />}
        <div>Description</div>
        <div className="flex-grow" />
        {showQty && <div className="w-[100px]">Rate</div>}
        {showLineTotal && <div className="w-[100px]">Line Total</div>}
      </div>
      {totalOnly ? (
        <div className="flex flex-1 p-3 space-x-4">
          <div className="font-[800]">Products and Services</div>
          <div className="flex-grow" />
          <div className="w-[100px]">- -</div>
          <div className="w-[100px]">$100.00</div>
        </div>
      ) : (
        <div className="divide-y">
          {items("part")}
          {items("service")}
        </div>
      )}
    </div>
  );
};

export default LineItemPreview;
